import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import StaffList from './staff-list';
import { getStaff } from '../../actions/staff';
import { loadPageContent } from '../../actions/content';

import './my-staff.css';

class MyStaff extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'my-staff';
    this.staff = [];
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getStaff());
    dispatch({ type: 'CLEAR_EDIT_STAFF_MEMBER' });
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container" className="staff">
        <Row>
          <Col lg={12}>
            <PageTitle>My staff</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
        <StaffList
          staff={this.props.staff}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
        />
      </Grid> 
    );
  }
}

const mapStateToProps = (state) => {
  return {
    staff: state.staff.staff,
    fetched: state.staff.fetched,
    fetching: state.staff.fetching,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(MyStaff);



// WEBPACK FOOTER //
// ./src/components/my-staff/index.jsx